<template>
  <fuit-or-yogurt
    :initialValue="state"
    :student="studentName"
    :title="title"
    @updatedElement="propagateChange"
    ref="element" />
</template>
<script>
import FuitOrYogurt from './FuitOrYogurt.vue'

export default {
  components: { FuitOrYogurt },
  created: function () {
    this.state = this.$attrs.student ? this.$attrs.student.dessertType : this.byDefault
  },
  props: {
    title: {
      type: String,
      default: () => 'Postre'
    },
    studentName: String
  },
  data: () => ({
    enabled: false,
    byDefault: 'fruta',
    state: ''
  }),
  methods: {
    setValue: function (value) {
      this.state = value
      this.$refs.element.setValue(value)
    },
    setEnable: function (value) {
      this.enabled = value
      this.$refs.element.setEnable(value)
    },
    propagateChange: function (item) {
      this.$emit('updatedElement',
        { dessertType: item.value }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/DessertType.vue